export const links = {
  arg: {
    international: [
      {
        cityId: 1338265,
        cityName: 'Santiago de Chile',
      },
      {
        cityId: 1318537,
        cityName: 'Miami',
      },
      {
        cityId: 1335602,
        cityName: 'Río de Janeiro',
      },
      {
        cityId: 1279817,
        cityName: 'Barcelona',
      },
      {
        cityId: 1286375,
        cityName: 'Cancún',
      },
    ],
    national: [
      {
        cityId: 1336424,
        cityName: 'Rosario',
      },
      {
        cityId: 1285525,
        cityName: 'Córdoba',
      },
      {
        cityId: 1317979,
        cityName: 'Mendoza',
      },
      {
        cityId: 1339523,
        cityName: 'Salta',
      },
      {
        cityId: 1317933,
        cityName: 'Mar del Plata',
      },
    ],
    random: [
      {
        'group-1': [
          {
            cityId: 1326681,
            cityName: 'Orlando',
          },
          {
            cityId: 1338265,
            cityName: 'Santiago de Chile',
          },
          {
            cityId: 1327843,
            cityName: 'París',
          },
          {
            cityId: 1328252,
            cityName: 'Punta del Este',
          },
          {
            cityId: 1340585,
            cityName: 'Salvador',
          },
        ],
      },
      {
        'group-2': [
          {
            cityId: 1324298,
            cityName: 'Nueva York',
          },
          {
            cityId: 1295096,
            cityName: 'Florianópolis',
          },
          {
            cityId: 1317380,
            cityName: 'Madrid',
          },
          {
            cityId: 1304467,
            cityName: 'Iguazú',
          },
          {
            cityId: 1321191,
            cityName: 'Natal',
          },
        ],
      },
      {
        'group-3': [
          {
            cityId: 1328096,
            cityName: 'Playa del Carmen',
          },
          {
            cityId: 1282466,
            cityName: 'Buenos Aires',
          },
          {
            cityId: 1315650,
            cityName: 'Londres',
          },
          {
            cityId: 1282012,
            cityName: 'Bariloche',
          },
          {
            cityId: 1320384,
            cityName: 'Montevideo',
          },
        ],
      },
      {
        'group-4': [
          {
            cityId: 2785282,
            cityName: 'Buzios',
          },
          {
            cityId: 1336393,
            cityName: 'Roma',
          },
          {
            cityId: 2523139,
            cityName: 'Varadero',
          },
          {
            cityId: 1835010,
            cityName: 'La Habana',
          },
          {
            cityId: 1313731,
            cityName: 'Las Vegas',
          },
        ],
      },
      {
        'group-5': [
          {
            cityId: 1330536,
            cityName: 'Punta Cana',
          },
          {
            cityId: 1276228,
            cityName: 'Isla de San Andrés',
          },
          {
            cityId: 1286177,
            cityName: 'Cartagena de Indias',
          },
          {
            cityId: 1317817,
            cityName: 'Maceió',
          },
          {
            cityId: 1304485,
            cityName: 'Foz de Iguazú',
          },
        ],
      },
    ],
  },
  mex: {
    international: [
      {
        cityId: 1313731,
        cityName: 'Las Vegas',
      },
      {
        cityId: 1318537,
        cityName: 'Miami',
      },
      {
        cityId: 1313765,
        cityName: 'Los Ángeles',
      },
      {
        cityId: 1327843,
        cityName: 'París',
      },
      {
        cityId: 1317380,
        cityName: 'Madrid',
      },
    ],
    national: [
      {
        cityId: 1275960,
        cityName: 'Acapulco',
      },
      {
        cityId: 1321027,
        cityName: 'Mazatlán',
      },
      {
        cityId: 1286375,
        cityName: 'Cancún',
      },
      {
        cityId: 1330727,
        cityName: 'Puerto Vallarta',
      },
      {
        cityId: 1320204,
        cityName: 'Monterrey',
      },
    ],
    random: [
      {
        'group-1': [
          {
            cityId: 1326681,
            cityName: 'Orlando',
          },
          {
            cityId: 1336393,
            cityName: 'Roma',
          },
          {
            cityId: 1277512,
            cityName: 'Amsterdam',
          },
          {
            cityId: 1279817,
            cityName: 'Barcelona',
          },
          {
            cityId: 1360994,
            cityName: 'Toronto',
          },
        ],
      },
      {
        'group-2': [
          {
            cityId: 1302877,
            cityName: 'Huatulco',
          },
          {
            cityId: 1315650,
            cityName: 'Londres',
          },
          {
            cityId: 1363293,
            cityName: 'Manzanillo',
          },
          {
            cityId: 1318553,
            cityName: 'Mérida',
          },
          {
            cityId: 1287078,
            cityName: 'Cozumel',
          },
        ],
      },
      {
        'group-3': [
          {
            cityId: 1328096,
            cityName: 'Playa del Carmen',
          },
          {
            cityId: 1323889,
            cityName: 'Nuevo Vallarta',
          },
          {
            cityId: 2900462,
            cityName: 'Mexico City',
          },
          {
            cityId: 1349105,
            cityName: 'Venecia',
          },
          {
            cityId: 1297292,
            cityName: 'Guadalajara',
          },
        ],
      },
      {
        'group-4': [
          {
            cityId: 1835010,
            cityName: 'La Habana',
          },
          {
            cityId: 1318111,
            cityName: 'Ciudad de México',
          },
          {
            cityId: 1286177,
            cityName: 'Cartagena de Indias',
          },
          {
            cityId: 1282466,
            cityName: 'Buenos Aires',
          },
          {
            cityId: 1281624,
            cityName: 'Bogotá',
          },
        ],
      },
      {
        'group-5': [
          {
            cityId: 2523139,
            cityName: 'Varadero',
          },
          {
            cityId: 1324298,
            cityName: 'Nueva York',
          },
          {
            cityId: 1295110,
            cityName: 'Florencia',
          },
          {
            cityId: 1280146,
            cityName: 'Berlín',
          },
          {
            cityId: 1338935,
            cityName: 'Shanghai',
          },
        ],
      },
    ],
  },
  col: {
    international: [
      {
        cityId: 1286375,
        cityName: 'Cancún',
      },
      {
        cityId: 1317380,
        cityName: 'Madrid',
      },
      {
        cityId: 1327843,
        cityName: 'París',
      },
      {
        cityId: 1318537,
        cityName: 'Miami',
      },
      {
        cityId: 1324298,
        cityName: 'Nueva York',
      },
    ],
    national: [
      {
        cityId: 1286177,
        cityName: 'Cartagena',
      },
      {
        cityId: 1317855,
        cityName: 'Medellín',
      },
      {
        cityId: 1276228,
        cityName: 'San Andrés',
      },
      {
        cityId: 1339769,
        cityName: 'Santa Marta',
      },
      {
        cityId: 1285047,
        cityName: 'Cali',
      },
    ],
    random: [
      {
        'group-1': [
          {
            cityId: 1281624,
            cityName: 'Bogotá',
          },
          {
            cityId: 1330536,
            cityName: 'Punta Cana',
          },
          {
            cityId: 1351650,
            cityName: 'Villavicencio',
          },
          {
            cityId: 1282466,
            cityName: 'Buenos Aires',
          },
          {
            cityId: 1303706,
            cityName: 'Ibagué',
          },
        ],
      },
      {
        'group-2': [
          {
            cityId: 1326681,
            cityName: 'Orlando',
          },
          {
            cityId: 1280328,
            cityName: 'Bucaramanga',
          },
          {
            cityId: 1328096,
            cityName: 'Playa del Carmen',
          },
          {
            cityId: 1279817,
            cityName: 'Barcelona',
          },
          {
            cityId: 1328371,
            cityName: 'Pereira',
          },
        ],
      },
      {
        'group-3': [
          {
            cityId: 1330464,
            cityName: 'Panamá',
          },
          {
            cityId: 1835010,
            cityName: 'La Habana',
          },
          {
            cityId: 1329258,
            cityName: 'Playa Blanca',
          },
          {
            cityId: 1352328,
            cityName: 'Washington',
          },
          {
            cityId: 1336393,
            cityName: 'Roma',
          },
        ],
      },
      {
        'group-4': [
          {
            cityId: 1276178,
            cityName: 'Andes',
          },
          {
            cityId: 1314769,
            cityName: 'Lima',
          },
          {
            cityId: 1313765,
            cityName: 'Los Ángeles',
          },
          {
            cityId: 1286441,
            cityName: 'Cusco',
          },
          {
            cityId: 1335602,
            cityName: 'Río de Janeiro',
          },
        ],
      },
      {
        'group-5': [
          {
            cityId: 2900462,
            cityName: 'Mexico City',
          },
          {
            cityId: 2523139,
            cityName: 'Varadero',
          },
          {
            cityId: 1314211,
            cityName: 'San Petersburgo',
          },
          {
            cityId: 1318111,
            cityName: 'Ciudad de México',
          },
          {
            cityId: 1338265,
            cityName: 'Santiago de Chile',
          },
        ],
      },
    ],
  },
  bra: {
    international: [],
    national: [],
    random: [],
  },
};
